/* eslint-disable react/forbid-prop-types */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { RideButton, RideGlCheckOutline, RideIcCompleteHealthLight } from '@rimac-seguros/ride-system-components';
import { Checkout } from 'checkout-component-react';

import { getFormatMount, formatPrice, getFormatDecimalMount } from '../../../utils/helpers';

const detailItems = [
  {
    id: 1,
    title: 'Plan elegido',
    subtitle: 'Seguro en casa',
  },
  {
    id: 2,
    title: 'Asegurados',
    subtitle: '1 titular',
  },
  {
    id: 3,
    title: 'Vigencia de póliza',
    subtitle: '1 año con renovación automática',
  },
];

export const AmountActual = ({ amount }) => (
  <div className="amount-actual">
    <span className="amount-actual--symbol">S/</span>
    <span className="amount-actual--price">
      {formatPrice(getFormatMount(String(amount)))}
      <span className="amount-actual--price--decimal">
        .
        {getFormatDecimalMount(String(amount))}
      </span>
    </span>
    <span className="amount-actual--frequency">&nbsp;/ al mes</span>
  </div>
);

export const AmountAfter = ({ price, dscto }) => (
  dscto ? (
    <div className="amount-after">
      <p className="amount-after__price">
        S/
        {formatPrice(getFormatMount(String((price).toFixed(2))))}
        <span className="amount-after__price">
          .
          {getFormatDecimalMount(String((price).toFixed(2)))}
        </span>
      </p>
      <span className="tag green-aqua">
        -
        {dscto}
        % dscto
      </span>
    </div>
  ) : ''
);

const calcDetail = (item, coverageSelected) => {
  switch (item) {
    case 1:
      return coverageSelected;
    case 2: return '1 Titular';
    case 3: return '1 año con renovación automática';
    default: return '';
  }
};

export const ItemDetails = ({ coverageSelected: { title }, id }) => {
  const detailItemsToMap = id === 'pay' ? [...detailItems] : [...detailItems].splice(0, 2);

  return (
    <div className="sel-detail__items hide-mobile">
      {detailItemsToMap.map((item) => (
        <div key={item.id} className="item-detail">
          <div className="item-detail__title">
            <RideGlCheckOutline size="medium" />
            {item.title}
          </div>
          <div className="item-detail__subtitle">
            {calcDetail(item.id, title.value)}
          </div>
        </div>
      ))}
    </div>
  );
};

const SelectionDetail = ({
  coverageSelected: { title, price }, handleClick, loading, id, insuredLength, disabledButton, planSelected, isPayment,
  isTermsChecked,
}) => {
  useEffect(() => {
    // hide button side component and rename button payment
    setTimeout(() => {
      const btnText = document.querySelector('#btnPayment');
      if (btnText) {
        btnText.innerHTML = 'Pagar';
      }
    }, [100]);
  }, []);

  return (
    <div className="sel-detail">
      <div className="sel-detail__title">
        {title.head}
      </div>
      <div className="price-box">
        <p className="price-box_titlemb hide-desktop">{title.headBox || 'COBERTURA REGULAR'}</p>
        <div className="price-box__price">
          {
            planSelected.discount.length > 0
              ? (
                <div className="amount-content">
                  <AmountAfter price={price} dscto={planSelected.discount[0].porcDescuento} />
                  <AmountActual amount={planSelected.priceDiscount} />
                </div>
              ) : <AmountActual amount={price} />
          }

          <RideButton
            text="Continuar"
            type="primary"
            onClick={handleClick}
            loading={loading}
            size="large"
            id={id}
            disabled={disabledButton}
            className="flex lg:hidden"
          />
        </div>
        <div className="price-box_icon">
          <RideIcCompleteHealthLight size="x-large" />
        </div>
      </div>
      <ItemDetails coverageSelected={{ title, price }} id={id} />
      {isPayment && (
        <div className={`class custom-btn-pay ${isTermsChecked ? '' : 'btn-hidden'}`}>
          <Checkout type="button" className="btn__primary cober-btn btn__checkout-custom" />
          {!isTermsChecked && (
            <button type="button" className="btn__primary cober-btn" disabled>Pagar</button>
          )}
        </div>
      )}
      {insuredLength === 1 && (
        <RideButton
          text="Continuar"
          type="primary"
          onClick={handleClick}
          loading={loading}
          size="x-large"
          id={id}
          disabled={disabledButton}
          className="hidden lg:flex"
        />
      )}
    </div>
  );
};

AmountActual.propTypes = {
  amount: PropTypes.node.isRequired,
};

AmountAfter.propTypes = {
  price: PropTypes.node.isRequired,
  dscto: PropTypes.node.isRequired,
};

SelectionDetail.defaultProps = {
  insuredLength: 1,
  id: null,
  disabledButton: false,
  isPayment: false,
};

SelectionDetail.propTypes = {
  coverageSelected: PropTypes.any.isRequired,
  planSelected: PropTypes.any.isRequired,
  handleClick: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  id: PropTypes.string,
  insuredLength: PropTypes.number,
  disabledButton: PropTypes.bool,
  isPayment: PropTypes.bool,
  isTermsChecked: PropTypes.bool.isRequired,
};

ItemDetails.defaultProps = {
  id: null,
};

ItemDetails.propTypes = {
  coverageSelected: PropTypes.any.isRequired,
  id: PropTypes.string,
};

export default SelectionDetail;
